import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { ThaiQuatrefoil, ThaiStar, ThaiDivider } from './ThaiMotif';

const contactInfo = [
  {
    icon: <EmailIcon />,
    label: 'Email',
    value: 'kasidejcha.bas@gmail.com',
    color: '#C8A24D',
  },
  {
    icon: <LocationOnIcon />,
    label: 'Location',
    value: 'Bangkok, Thailand',
    color: '#5C3D2E',
  },
];

const Contact: React.FC = () => {
  return (
    <Box
      id="contact"
      sx={{
        py: { xs: 10, md: 14 },
        background: '#FAF6EE',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Thai motif decorations */}
      <ThaiQuatrefoil size={100} opacity={0.04} sx={{ top: '8%', right: '5%' }} />
      <ThaiStar size={80} opacity={0.035} rotate={-12} sx={{ bottom: '10%', left: '4%' }} />
      <ThaiStar size={35} opacity={0.025} rotate={20} sx={{ top: '30%', left: '8%' }} />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="overline"
            sx={{
              color: '#C8A24D',
              fontWeight: 600,
              letterSpacing: 3,
              fontSize: '0.8rem',
              mb: 1.5,
              display: 'block',
            }}
          >
            CONTACT
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontSize: { xs: '1.8rem', md: '2.5rem' }, mb: 1, color: '#2A231C' }}
          >
            Let's{' '}
            <Box component="span" className="serif-heading" sx={{ color: '#C8A24D' }}>
              Connect
            </Box>
          </Typography>
          <ThaiDivider />
          <Typography
            variant="body1"
            sx={{
              color: '#7A6E60',
              maxWidth: 480,
              mx: 'auto',
              fontSize: '0.95rem',
            }}
          >
            I'm always excited to discuss new opportunities, projects, or
            just have a friendly chat about technology.
          </Typography>
        </Box>

        <Grid container spacing={3} justifyContent="center">
          {contactInfo.map((info, index) => (
            <Grid size={{ xs: 12, md: 6 }} key={index}>
              <Box
                className="card"
                sx={{
                  p: 4,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  cursor: 'default',
                }}
              >
                <Box
                  sx={{
                    width: 52,
                    height: 52,
                    borderRadius: '12px',
                    background: `${info.color}10`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: info.color,
                    mb: 2,
                    '& svg': { fontSize: '1.4rem' },
                  }}
                >
                  {info.icon}
                </Box>
                <Typography
                  variant="body2"
                  sx={{ color: '#9CA3AF', fontSize: '0.8rem', mb: 0.5, letterSpacing: 0.5 }}
                >
                  {info.label}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: '#2A231C',
                    fontWeight: 600,
                    fontSize: '0.95rem',
                  }}
                >
                  {info.value}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Contact;
